export const FEATURES_STATE_TOKEN = 'FEATURES';

